
import { defineComponent, ref } from "vue"
import { useStore } from "vuex"
import { AutocallNumber } from "@/service/constant.json"

export default defineComponent({
  setup() {
    const { dispatch } = useStore()
    const showText = ref("")

    dispatch("complete/classify", [
      "호출 결과를 문자메시지로 알려드릴테니\n잠시만 기다려주세요!",
      "내 전화번호 노출 없이 상대방과 통화하세요!",
      `${AutocallNumber}로 발신된 문자를 확인한 뒤\n링크를 눌러주세요!`,
      "호출 결과를 문자메시지로 알려드릴테니\n잠시만 기다려주세요!",
    ]).then((data) => {
      showText.value = data
    })
    return {
      showText,
    }
  },
})
